(function () {
	$(document).ready(function(){
		if(!$.cookie('userTag') || !$.cookie('usertag')) {
			setTimeout(function () {
				flushUserTag();
			}, 2000);
		}
	});
	
	function flushUserTag(){
		$.ajax({  
			type:"get",
			dataType:"jsonp",
			url: window._qiwa.webSettings.flashUserTagUrl,
			crossDomain:true,
			jsonpCallback:"setUserInfo",
			success: function(data){
				flushUserTagCallback(data);
			},
			beforeSend:function(){
			}, 
			complete:function(data,status){
			}  
		});
	}

	function flushUserTagCallback(data){
		$.cookie('usertag', data.userTag, {
			path: '/'
		});
		$.cookie('userTag', data.userTag, {
			path: '/'
		});
		$.cookie('userId', data.userId, {
			path: '/'
		});
	}
})();


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/qiwa-common_m/lib/flushUserTag.js
// module id = 275
// module chunks = 4